import { _FallbackBackgroundBase } from './fallbackBackgroundBase'

/** 兜底背景图,默认样式 */
export class _FallbackBackgroundDefault extends _FallbackBackgroundBase {
  cssType: 'default' | 'larger' = 'default'
  protected initPC(): this {
    this['--fallback-background-font-size'] = '0.68rem'
    return this
  }
  protected initH5(): this {
    this['--fallback-background-font-size'] = '0.88rem'
    return this
  }
}
